/*
 *
 * PatientSchedule saga
 *
 */
import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchPatientSessionsAPI, findUser } from 'utils/api';
import { getErrorMessage } from 'utils/errorUtils';

import {
	fetchProfileFailure,
	fetchProfileSuccess,
	fetchSessionsFailure,
	fetchSessionsSuccess,
} from './actions';
import { FETCH_PROFILE, FETCH_SESSIONS } from './constants';

export function* fetchSessionsSaga() {
	const response = yield call(fetchPatientSessionsAPI);
	if (response && response.response && response.response.status >= 400) {
		yield put(fetchSessionsFailure(getErrorMessage(response)));
		return;
	}
	yield put(fetchSessionsSuccess(response));
}

export function* fetchProfileSaga(action) {
	const response = yield call(findUser, { id: action.userId });
	if (response && response.response && response.response.status >= 400) {
		yield put(fetchProfileFailure(getErrorMessage(response)));
		return;
	}
	yield put(fetchProfileSuccess(response));
}

export default function* patientScheduleSaga() {
	yield takeLatest(FETCH_SESSIONS, fetchSessionsSaga);
	yield takeLatest(FETCH_PROFILE, fetchProfileSaga);
}
